import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: 'paywall',
    title: 'Paywall',
    loadChildren: () =>
      import('./components/paywall/paywall.routes').then((m) => m.routes),
  },
  {
    path: 'signup',
    title: 'Signup',
    loadChildren: () =>
      import('./components/signup/signup.routes').then((m) => m.routes),
  },
  // {
  //   path: 'subscription',
  //   title: 'Subscription',
  //   loadComponent: () =>
  //     import('./components/subscription/subscription.component').then(
  //       (m) => m.SubscriptionComponent
  //     ),
  // },
  {
    path: 'reset-password',
    title: 'Reset Password',
    loadChildren: () =>
      import('./components/reset-password/reset-password.routes').then(
        (m) => m.routes
      ),
  },
  {
    path: 'notfound',
    title: 'Not Found',
    component: PageNotFoundComponent,
  },
  { path: '**', redirectTo: '/signup', pathMatch: 'full' },
];
